import React, { useState, useEffect } from "react";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
// import { DatePicker } from "antd";
import Addunits from "../../core/modals/inventory/addunits";
// import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/inventory/addbrand";
import {
  ArrowLeft,
  // Calendar,
  ChevronDown,
  PlusCircle,
  Info,
  // LifeBuoy,
  List,
} from "feather-icons-react/build/IconComponents";
// import { useDispatch, useSelector } from "react-redux";
// import { setToogleHeader } from "../../core/redux/action";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import Axios from 'axios';
import {
  API_BASE_URL,
  INSERT_PROD,
  GET_USER_STORES,
  GET_TAXES_DATA,
  GET_VSTORE_PROD,
} from "../../Config";
import Swal from "sweetalert2";
// import { DatePicker } from "antd";
// import dayjs from "dayjs";
import AddCategoryList from "../../core/modals/inventory/addcategorylist";
import AddSubcategory from "../../core/modals/inventory/addsubcategory";
import AddVariant from "../../core/modals/inventory/addvariant";
import { Select as Myselect } from "antd";

const AddProduct = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [variantTypeData, setVariantTypeData] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [selectedWeight, setSelectedWeight] = useState("");
  const [selectedVType, setSelectedVType] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSaleUnit, setSelectedSaleUnit] = useState(null);
  const [selectedPuchrchaseUnit, setSelectedPurchaseUnit] = useState(null);
  const [storeFormData, setStoreFormData] = useState([]);
  const [unitsData, setUnitsData] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  // const [selectedCatOption, setSelectedCatOption] = useState(null);
  // const [selectedSubCatOption, setSelectedSubCatOption] = useState(null);
  // const [gettingProductId, setGettingProductId] = useState('');
  const [taxesData, setTaxesData] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const variantypesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_variantypes"),
    );
    const brandsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_BRAND"),
    );
    const categoryDatas = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY"),
    );
    const subcategoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Subcategories"),
    );
    const unitsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_UNITS"),
    );

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setCategoryData(categoryDatas);
      setSubCategoryData(subcategoryData);
      setVariantTypeData(variantypesData);
      setUnitsData(unitsData);
      setBrandsData(brandsData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`,
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.UserId) {
      const fetchStoresData = async () => {
        try {
          const response = await Axios.get(
            `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`,
            {
              params: {
                OrgId: userDataSession.OrgId,
              },
            },
          );
          setStoreData(response.data.ResultData);
        } catch (error) {
          console.error("Error fetching stores data:", error);
        }
      };

      fetchStoresData();
      console.log(
        storeFormData,
        "store form data getting from service userstores.",
      );
    }
  }, [userDataSession]);

  const route = all_routes;
  // const dispatch = useDispatch();

  // const data = useSelector((state) => state.toggle_header);

  const [formData, setFormData] = useState({
    Id: 0,
    CategoryId: 0,
    SubCategoryId: 0,
    BarCode: "",
    Name: "",
    Description: "",
    AvgPrice: 0.0,
    ImagePath: "",
    ImageUrl: "",
    TrackStock: false,
    IsCompositeItem: false,
    StoreWiseTaxes: 1,
    IsActive: 1,
    SoldbyWeight: 0,
    ProductSKU: "",
    HSN: "",
    Weight: 0.0,
    PackingWeight: 0.0,
    code: "",
    MRP: 0.0,
    SaleUnitId: "",
    PurchaseUnitId: "",
    // ManufacturedDate: "",
    // ExpiredDate: "",
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  const handleCatSelectChange = (selectedOption) => {
    // setSelectedCatOption(selectedOption);
    setFormData((prevState) => ({
      ...prevState,
      CategoryId: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleSubCatSelectChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      SubCategoryId: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleVariantTypeSelectChange = (selectedOptions) => {
    setSelectedVType(selectedOptions);
  };

  const handleBrandSelectChange = (selectedOption) => {
    setSelectedBrand(selectedOption);
  };

  const handlePurchaseUnitSelectChange = (selectedOption) => {
    setSelectedPurchaseUnit(selectedOption);
  };

  const handleSaleUnitSelectChange = (selectedOption) => {
    setSelectedSaleUnit(selectedOption);
  };

  // const handleMfdDateChange = (date) => {
  //   const formattedDate = dayjs(date).format("YYYY-MM-DD");
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     ManufacturedDate: formattedDate,
  //   }));
  //   console.log(formattedDate);
  // };

  // const handleExpDateChange = (date) => {
  //   const formattedDate = dayjs(date).format("YYYY-MM-DD");
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     ExpiredDate: formattedDate,
  //   }));
  //   console.log(formattedDate);
  // };

  const handleRadioChange = (event) => {
    setSelectedWeight(event.target.value);
    if (event.target.value === "each") {
      setFormData((prevState) => ({
        ...prevState,
        SoldbyWeight: "0",
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        SoldbyWeight: "1",
      }));
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked ? 1 : 0,
    }));
    console.log(name, checked ? 1 : 0);
  };

  const handleStorePriceChange = (index, event) => {
    const updatedStoreData = [...storeFormData];
    updatedStoreData[index] = {
      ...updatedStoreData[index],
      StorePrice: event.target.value,
    };
    setStoreFormData(updatedStoreData);
  };

  // #region Add Product func
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(storeFormData, "store form data sending to api add");
    if (isDuplicate) {
      Swal.fire("Error", "Duplicate product name not allowed", "error");
      return;
    }

    formData.PurchaseUnitId = selectedPuchrchaseUnit;
    formData.SaleUnitId = selectedSaleUnit;

    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      BrandId: selectedBrand ? selectedBrand.value : null,
      SaleUnitId: selectedSaleUnit ? selectedSaleUnit : null,
      PurchaseUnitId: selectedPuchrchaseUnit ? selectedPuchrchaseUnit : null,
      Product: {
        ...formData,
      },
      StoreProduct: storeFormData
        .filter((store) => store.isForSale)
        .map((store) => {
          const inStock = parseFloat(store.inStock) || 0;
          const addAdjStock = parseFloat(store.addAdjStock) || 0;
          const price = parseFloat(store.StorePrice) || 0;
          const taxId =
            store.taxId && store.taxId !== "0" ? JSON.parse(store.taxId).Id : 0;
          return {
            Id: 0,
            StoreId: store.StoreId,
            Prices: price,
            VendorId: 0,
            IsActive: 1,
            OptimalStock: store.optimalStock ? store.optimalStock : 0,
            TaxId: taxId,
            LowStock: store.lowStock ? store.lowStock : 0,
            IsForSale: 1,
            PriceInclusiveTax: store.priceInclusiveTax ? 1 : 0,
            InStock: inStock,
            addAdjStock: addAdjStock,
          };
        }),

      ProductVariants: selectedVType
        ? selectedVType.map((variant) => {
            const matchingVariant = variantTypeData.find(
              (data) => data.ItemId === variant.value,
            );

            return {
              Id: 0,
              VariantTypeId: variant.value,
              Value: variant.label,
              IsActive: 1,
              CalcVal: matchingVariant ? matchingVariant.DisplayValue : "",
            };
          })
        : [],
      OperationType: "Insert",
    };

    console.log(payload, "payload data before api sending");
    try {
      setSubmitBtnLoading(true);
      const response = await fetch(`${API_BASE_URL}${INSERT_PROD}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const datares = await response.json();
      console.log(datares, "api resposne..");

   if (datares[0].Success == 1) {
  setSubmitBtnLoading(false);
  Swal.fire({
    title: "Product added Successfully.",
    icon: "success",
  }).then((result) => {
    if (result.isConfirmed || result.isDismissed) {
      // Navigate and pass the 'refresh' flag
      navigate("/product-list", { state: { refresh: true } });
    }
  });
}
      setSubmitBtnLoading(false);
    } catch (error) {
      setSubmitBtnLoading(false);
      console.error("Error:", error);
    }
  };

  const getProductList = () => {
    if (!userDataSession?.OrgId || !userDataSession?.UserId) return;

    // const productId = selectedProduct ? selectedProduct.value : 0;

    const sessionKey = `products_${userDataSession.OrgId}_${userDataSession.UserId}`;

    const requestData = {
      OrgId: userDataSession.OrgId,
      CategoryId: 0,
      BarCode: "0",
      IsActive: 1,
      ProductId: 0,
      StoreId: 0,
      IsForSale: 1,
      UserId: userDataSession.UserId,
      Type: 0,
    };

    Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
      .then((response) => {
        if (response.data?.Status) {
          const products = response.data.ResultData;

          // 3️⃣ Save to sessionStorage
          sessionStorage.setItem(sessionKey, JSON.stringify(products));

          console.log("Products fetched from API & cached");
        } else {
          console.error("Error fetching data:", response.data?.Message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getProductList();
  }, [userDataSession]);
  // Use useEffect to update storeFormData when storeData changes
  useEffect(() => {
    if (storeData.length > 0) {
      setStoreFormData(
        storeData?.map((store) => ({
          ...store,
          isForSale: true,
          price: 0.0,
          priceInclusiveTax: false,
          lowStock: "",
          optimalStock: "",
          instock: "",
          addAdjStock: "",
          taxId: "0",
        })),
      );
    }
  }, [storeData]);

  const handleStoreCheckboxChange = (index, field) => (event) => {
    const { value, checked } = event.target;

    setStoreFormData((prevState) => {
      const newState = [...prevState];

      if (checked) {
        newState[index][field] = value;
      } else {
        delete newState[index][field];
      }

      return newState;
    });
  };

  const handleStoreInputChange = (index, field) => (event) => {
    const { value } = event.target;

    setStoreFormData((prevState) => {
      const newState = [...prevState];
      newState[index][field] = value;

      // Update instock value correctly when addAdjStock changes
      if (field === "addAdjStock") {
        newState[index]["inStock"] =
          parseFloat(newState[index]["initialStock"] || 0) +
          parseFloat(value || 0);
      } else if (field === "inStock") {
        // Store the initial inStock value
        newState[index]["initialStock"] = parseFloat(value || 0);
      }

      return newState;
    });
  };

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     minHeight: "2rem",
  //     height: "2.4rem",
  //   }),
  //   valueContainer: (provided) => ({
  //     ...provided,
  //     height: "1rem",
  //     padding: "0 6px",
  //   }),
  //   input: (provided) => ({
  //     ...provided,
  //     margin: "0",
  //   }),
  //   // indicatorsContainer: (provided) => ({
  //   //   ...provided,
  //   //   height: '1rem',
  //   // }),
  // };

const getSessionProducts = () => {
    if (!userDataSession?.OrgId || !userDataSession?.StoreId) return [];

    const sessionKey = `products_${userDataSession.OrgId}_0`;
    const data = sessionStorage.getItem(sessionKey);
    return data ? JSON.parse(data) : [];
  };

  const [isDuplicate, setIsDuplicate] = useState(false);
  // const [suggestions, setSuggestions] = useState([]);

  const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ keep other fields intact
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  // 👉 Only run duplicate logic for Product Name field
  if (name !== "Name") return;

  if (!value || value.trim().length < 1) {
    setIsDuplicate(false);
    return;
  }

  const products = getSessionProducts();

  // ❌ Exact duplicate check
  const exactMatch = products.some(
    (p) =>
      p.ProductName?.toLowerCase().trim() ===
      value.toLowerCase().trim()
  );

  setIsDuplicate(exactMatch);
};


  // const handleSelectSuggestion = (productName) => {
  //   setFormData({ Name: productName });
  //   setSuggestions([]);
  //   setIsDuplicate(true); // already exists
  // };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Product</h4>
              <h6>Create new product</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Products
                </Link>
              </div>
            </li>
          </ul>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />

                          <span>Product Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Product Name
                              <span className="fw-bold text-danger">*</span>
                            </label>
                            {/* <input
                              type="text"
                              className={`form-control ${isDuplicate ? "is-invalid" : ""}`}
                              placeholder="Enter Product name"
                              name="Name"
                              value={formData.Name || ""}
                              onChange={handleChange}
                              required
                            /> */}
                            <input
                              type="text"
                              className={`form-control ${isDuplicate ? "is-invalid" : ""}`}
                              placeholder="Enter Product name"
                              name="Name"
                              value={formData.Name}
                              onChange={handleChange}
                              autoComplete="off"
                              required
                            />
                            {isDuplicate && (
                              <div className="invalid-feedback">
                                This product name already exists
                              </div>
                            )}
                            {/* {suggestions.length > 0 && (
                              <ul className="list-group position-absolute w-100 z-3">
                                {suggestions.map((item) => (
                                  <li
                                    key={item.Id}
                                    className="list-group-item list-group-item-action"
                                    onClick={() =>
                                      handleSelectSuggestion(item.ProductName)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {item.ProductName}
                                  </li>
                                ))}
                              </ul>
                            )} */}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Barcode
                              <span className="fw-bold text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter barcode"
                              name="BarCode"
                              minLength={5}
                              value={formData.BarCode || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product list">
                            <label>MRP</label>
                            <input
                              type="number"
                              className="form-control list"
                              placeholder="Enter MRP"
                              name="MRP"
                              value={formData.MRP || ""}
                              onChange={handleChange}
                              onWheel={(e) => e.target.blur(e)}
                              // required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="addservice-info">
                        <div className="row">
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Brand</label>
                              <div className="row">
                                <div className="col-lg-10 col-sm-10 col-10">
                                  <Select
                                    className="select flex-grow-1"
                                    options={brandsData?.map((store) => ({
                                      value: store.ItemId,
                                      label: store.ItemValue,
                                    }))}
                                    placeholder="Choose brand"
                                    // styles={customStyles}
                                    onChange={handleBrandSelectChange}
                                    isClearable
                                  />
                                </div>
                                <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link
                                      to="#"
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#offcanvasRightBrandAdd"
                                      aria-controls="offcanvasRightBrandAdd"
                                    >
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>
                                Category
                                <span className="fw-bold text-danger">*</span>
                              </label>
                              <div className="row">
                                <div className="col-lg-10 col-sm-10 col-10">
                                  <Select
                                    className="select flex-grow-1"
                                    required
                                    options={categoryData?.map((store) => ({
                                      value: store.ItemId,
                                      label: store.ItemValue,
                                    }))}
                                    placeholder="Choose Category"
                                    // styles={customStyles}
                                    onChange={handleCatSelectChange}
                                  />
                                </div>
                                <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link
                                      to="#"
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#offcanvasRightCategoryAdd"
                                      aria-controls="offcanvasRightCategoryAdd"
                                    >
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks">
                              <label>Sub Category</label>
                              <div className="row">
                                <div className="col-lg-10 col-sm-10 col-10">
                                  <Select
                                    className="select"
                                    options={subCategoryData?.map((store) => ({
                                      value: store.ItemId,
                                      label: store.ItemValue,
                                    }))}
                                    placeholder="Choose Subcategory"
                                    // styles={customStyles}
                                    onChange={handleSubCatSelectChange}
                                  />
                                </div>
                                <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link
                                      to="#"
                                      data-bs-toggle="offcanvas"
                                      data-bs-target="#offcanvasRightSubCategoryAdd"
                                      aria-controls="offcanvasRightSubCategoryAdd"
                                    >
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="add-product-new">
                        <div className="row">
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">HSN</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter HSN"
                                name="HSN"
                                value={formData.HSN || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Product Code</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter product code"
                                name="code"
                                maxLength={8}
                                value={formData.code || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Product SKU</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter SKU"
                                name="ProductSKU"
                                value={formData.ProductSKU || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="add-product-new">
                        <div className="row">
                          {/* <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Image</label>
                              <input className="form-control" type="file" />
                            </div>
                          </div> */}
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">
                                Price
                                <span className="fw-bold text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                placeholder="Enter price"
                                name="AvgPrice"
                                value={formData.AvgPrice || ""}
                                onChange={handleChange}
                                onWheel={(e) => e.target.blur(e)}
                              />
                            </div>
                          </div>
                          {/* <div className="col-lg-4 col-sm-6 col-12">
                            <div className="d-flex">
                              <div className="input-blocks">
                                <div className="mb-3 add-product d-flex flex-column">
                                  <label className="form-label">
                                    Manufature Date
                                  </label>
                                  <div className="input-groupicon calender-input">
                                    <Calendar className="info-img" />
                                    <DatePicker
                                      onChange={handleMfdDateChange}
                                      type="date"
                                      className="datetimepicker"
                                      name="ManufacturedDate"
                                      dateFormat="dd-MM-yyyy"
                                      placeholder="Choose Date"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="input-blocks ms-3">
                                <div className="mb-3 add-product d-flex flex-column">
                                  <label className="form-label">
                                    Expired Date
                                  </label>
                                  <div className="input-groupicon calender-input">
                                    <Calendar className="info-img" />
                                    <DatePicker
                                      onChange={handleExpDateChange}
                                      type="date"
                                      className="datetimepicker"
                                      name="ExpiredDate"
                                      dateFormat="dd-MM-yyyy"
                                      placeholder="Choose Date"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                          <div className="col-lg-4 col-sm-12 col-12">
                            <div className="input-blocks">
                              <label>Variant Type</label>
                              <div className="row">
                                <div className="col-lg-12 col-sm-12 col-12">
                                  <Select
                                    isMulti
                                    className="select"
                                    options={variantTypeData?.map((store) => ({
                                      value: store.ItemId,
                                      label: store.ItemValue,
                                    }))}
                                    placeholder="Choose"
                                    styles={{
                                      multiValue: (base) => ({
                                        ...base,
                                        borderRadius: "8px",
                                        backgroundColor: "#007bff",
                                      }),
                                      multiValueLabel: (base) => ({
                                        ...base,
                                        color: "#fff",
                                        borderRadius: "5px",
                                      }),
                                    }}
                                    onChange={handleVariantTypeSelectChange}
                                  />
                                </div>
                                {/* <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link
                                      to="#"
                                      className=""
                                      data-bs-toggle="modal"
                                      data-bs-target="#add-units"
                                    >
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-4 col-sm-12 col-12">
                            <div className="input-blocks">
                              <label>
                                Sale Unit
                                <span className="fw-bold text-danger">*</span>
                              </label>
                              <Myselect
                                className="w-100 h-100"
                                options={unitsData?.map((store) => ({
                                  value: store.ItemId,
                                  label: store.ItemValue,
                                }))}
                                placeholder="Choose sale unit"
                                onChange={handleSaleUnitSelectChange}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-sm-12 col-12">
                            <div className="input-blocks">
                              <label>Purchase Unit</label>
                              <Myselect
                                className="w-100 h-100"
                                options={unitsData?.map((store) => ({
                                  value: store.ItemId,
                                  label: store.ItemValue,
                                }))}
                                placeholder="Choose purchase unit"
                                onChange={handlePurchaseUnitSelectChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Editor */}
                        <div className="col-lg-12">
                          <div className="input-blocks summer-description-box transfer mb-3">
                            <label>Description</label>
                            <textarea
                              className="form-control h-100"
                              rows={5}
                              placeholder="Enter product description"
                              name="Description"
                              value={formData.Description || ""}
                              onChange={handleChange}
                            />
                            <p className="mt-1">Maximum 60 Characters</p>
                          </div>
                        </div>
                        {/* /Editor */}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="accordion-card-one accordion"
                  id="accordionExample2"
                >
                  <div className="accordion-ite d-flex">
                    <div className="accordion-body">
                      <label className="d-block">Sold By</label>
                      <div className="input-blocks add-products d-flex">
                        <div className="single-pill-product me-5">
                          <ul
                            className="nav nav-pills"
                            id="pills-tab1"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <span
                                className="custom_radio me-4 mb-0 active"
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                              >
                                <input
                                  type="radio"
                                  className="form-control"
                                  name="each"
                                  value="each"
                                  checked={selectedWeight === "each"}
                                  onChange={handleRadioChange}
                                />
                                <span className="checkmark" /> Each
                              </span>
                            </li>
                            <li className="nav-item" role="presentation">
                              <span
                                className="custom_radio me-2 mb-0"
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected="false"
                              >
                                <input
                                  type="radio"
                                  className="form-control"
                                  name="Weight"
                                  value="weight"
                                  checked={selectedWeight === "weight"}
                                  onChange={handleRadioChange}
                                />
                                <span className="checkmark" /> Weight
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-body">
                      <label className="d-block">Product Type</label>
                      <div className="input-blocks add-products d-flex">
                        <div className="single-pill-product me-5">
                          <div className="input-block add-lists d-flex">
                            <label className="checkboxs">
                              <input
                                type="checkbox"
                                name="TrackStock"
                                checked={formData.TrackStock}
                                onChange={handleCheckboxChange}
                              />
                              <span className="checkmarks" />
                              Track Stock
                            </label>
                            <label className="checkboxs ms-4">
                              <input
                                type="checkbox"
                                name="IsCompositeItem"
                                checked={formData.IsCompositeItem}
                                onChange={handleCheckboxChange}
                              />
                              <span className="checkmarks" />
                              Combo Product
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="accordion-card-one accordion"
                  id="accordionExample4"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingFour">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-controls="collapseFour"
                      >
                        <div className="text-editor add-list">
                          <div className="addproduct-icon list">
                            <h5>
                              <List className="add-info" />
                              <span>Stores</span>
                            </h5>
                            <Link to="#">
                              <ChevronDown className="chevron-down-add" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample4"
                    >
                      <div className="accordion-body">
                        <div className="text-editor add-list add">
                          <div className="row">
                            <div className="col-lg-12 col-sm-12 col-12">
                              <div
                                className="table-responsive"
                                style={{ height: "20rem", overflowY: "auto" }}
                              >
                                <table className="table datanew dataTable no-footer">
                                  <thead className="sticky-top">
                                    <tr>
                                      <th>#</th>
                                      <th>For Sale</th>
                                      <th>Store Name</th>
                                      <th>Tax</th>
                                      <th>Price</th>
                                      <th>Price inc Tax</th>
                                      <th>Low Stock</th>
                                      <th>Optimal Stock</th>
                                      <th>Current Stock</th>
                                      <th>Add/Adj Stock</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {storeFormData?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td className="text-center">
                                          <input
                                            type="checkbox"
                                            checked={item.isForSale}
                                            onChange={handleStoreCheckboxChange(
                                              index,
                                              "isForSale",
                                            )}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </td>
                                        <td title={item.Name}>
                                          {item.Name.length > 20
                                            ? item.Name.substring(0, 15) + "..."
                                            : item.Name}
                                        </td>
                                        <td>
                                          <select
                                            className="form-select"
                                            value={item.taxId}
                                            onChange={handleStoreInputChange(
                                              index,
                                              "taxId",
                                            )}
                                          >
                                            <option value="0">No Tax</option>
                                            {taxesData?.map((tax) => (
                                              <option
                                                key={tax.Id}
                                                value={JSON.stringify({
                                                  Id: tax.Id,
                                                  // TaxRate: tax.TaxRate,
                                                  // SGSTRate: tax.SGSTRate,
                                                  // CGSTRate: tax.CGSTRate,
                                                  // IGSTRate: tax.IGSTRate,
                                                })}
                                              >
                                                {tax.TaxRate}%
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        {/* <td>
                                          <input
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter price"
                                            name="price"
                                            value={item.price}
                                            onChange={handleStoreInputChange(
                                              index,
                                              "price"
                                            )}
                                          />
                                        </td> */}
                                        <td>
                                          <input
                                            className="form-control"
                                            type="number"
                                            placeholder="Enter price"
                                            style={{ width: "6rem" }}
                                            value={item.StorePrice}
                                            onChange={(event) =>
                                              handleStorePriceChange(
                                                index,
                                                event,
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <input
                                            type="checkbox"
                                            checked={item.priceInclusiveTax}
                                            onChange={handleStoreCheckboxChange(
                                              index,
                                              "priceInclusiveTax",
                                            )}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            className="form-control"
                                            type="number"
                                            style={{ width: "5rem" }}
                                            placeholder="0"
                                            name="lowstock"
                                            value={item.lowstock}
                                            onChange={handleStoreInputChange(
                                              index,
                                              "lowStock",
                                            )}
                                            onWheel={(e) => e.target.blur(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            className="form-control"
                                            type="number"
                                            style={{ width: "5rem" }}
                                            placeholder="0"
                                            value={item.optimalstock}
                                            onChange={handleStoreInputChange(
                                              index,
                                              "optimalStock",
                                            )}
                                            onWheel={(e) => e.target.blur(e)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            className="form-control"
                                            type="text"
                                            style={{ width: "5rem" }}
                                            placeholder="0"
                                            name="instock"
                                            value={item.inStock}
                                            // onChange={handleStoreInputChange(index, 'inStock')}
                                            readOnly
                                          />
                                        </td>
                                        <td>
                                          <input
                                            className="form-control"
                                            type="number"
                                            style={{ width: "5rem" }}
                                            placeholder="0"
                                            name="addAdjStock"
                                            value={item.addAdjStock}
                                            onChange={handleStoreInputChange(
                                              index,
                                              "addAdjStock",
                                            )}
                                            onWheel={(e) => e.target.blur(e)}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4 ">
                <Link to="/product-list">
                  <button
                    type="button"
                    className="btn btn-cancel me-2 mt-2 rounded"
                  >
                    Cancel
                  </button>
                </Link>
                <button
                  type="submit"
                  className="btn btn-submit me-2 mt-2 rounded"
                >
                  {submitBtnLoading ? "Submitting..." : "Save Product"}
                </button>
              </div>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <Addunits />
      <AddCategoryList />
      <AddSubcategory />
      <AddBrand />
      <AddVariant />
    </div>
  );
};

export default AddProduct;
